import React, { useMemo } from "react";
import UserContentNavigation from "pages/Account/UserContentNavigation";
import Page from "pages/Page";
import { Content, AddAlt24 } from "@sia/style-guide";
import { BackButton } from "@sia/style-guide/dist/components/BackButton/BackButton";
import { useHistory } from "react-router-dom";
import pgAdapter from "common/Adapters/PGAdapter/PGAdapter";
import { useEffect, useContext } from "react";
import GlobalContext from "contexts/GlobalContext";
import { Table, usePathFactory, useTranslator } from "@sia/style-guide";
import { useState } from "react";
import { renderMobileCellValue } from "../Memberships/functions";
import "./BBFPage.scss";
import BBFForm from "./BBFForm";
const getBBFTableColumns = (translate) => [
  { name: "mobile", label: "Daten", class: "small-only" },
  {
    name: "year",
    label: translate("account.customer-data.bbf.table.year"),
    class: "medium-up",
  },
  {
    name: "product_name",
    label: translate("account.customer-data.bbf.table.product_name"),
    class: "medium-up from-date",
  },
  {
    name: "number_of_employees",
    label: translate("account.customer-data.bbf.table.number_of_employees"),
    class: "medium-up from-date",
  },
  {
    name: "membership_in_associations",
    label: translate("account.customer-data.bbf.table.membership_in_associations"),
    class: "medium-up from-date",
  },
  {
    name: "has_formation",
    label: translate("account.customer-data.bbf.table.has_formation"),
    class: "medium-up from-date",
  },
  {
    name: "formation_specialisation",
    label: translate("account.customer-data.bbf.table.formation_specialisation"),
    class: "medium-up from-date",
  },
];

const getBBFData = (language, columns, setItems, translate, currentYear, setIsPlusable) => {
  pgAdapter.getBBFHistory(language, ({ data }) => {
    if (data.membership_history.length === 0) {
      setIsPlusable(true);
      return;
    }
    const data_items = Object.entries(data.membership_history)
      .map((el) => {
        const line = el[1].lines[0];
        let item_aux = {
          id: el[0],
          year: el[0],
          product_name: line.product_name,
          number_of_employees: line.number_of_employees,
          membership_in_associations: line.mebership_in_associations,
          has_formation: translate(`account.customer-data.bbf.table.has_formation_${line.has_formation ? "yes" : "no"}`),
          formation_specialisation: line.formation_specialisation,
        };
        item_aux["mobile"] = renderMobileCellValue(item_aux, columns);
        return item_aux;
      })
      .sort((a, b) => {
        return parseInt(a.year) < parseInt(b.year) ? 1 : -1;
      });
    setIsPlusable(parseInt(currentYear) > parseInt(data_items[0].year));
    setItems(data_items);
  });
};

const BBFPage = () => {
  const history = useHistory();
  const pathFactory = usePathFactory();
  const translate = useTranslator();
  const GlobalContextValue = useContext(GlobalContext);
  const language = GlobalContextValue.language;
  const [items, setItems] = useState([]);
  const currentYear = new Date().getFullYear();
  const [isPlusable, setIsPlusable] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);
  useEffect(() => {
    getBBFData(language, columns, setItems, translate, currentYear, setIsPlusable);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const columns = useMemo(() => getBBFTableColumns(translate), [translate]);

  return (
    <Page contentNavigation={<UserContentNavigation />} title={"account.name"} className={"bbf-page"}>
      <Content className={"memberships"} centeredTitle={true}>
        <h1>
          <BackButton onClick={() => history.push(pathFactory.create("account/customer-data"))} />
          {translate("account.customer-data.bbf.description")}
        </h1>
        <div className={"bbf-table-header"}>
          <h3>{translate("account.customer-data.bbf.table.title")}</h3>
          {isPlusable ? <AddAlt24 onClick={() => setIsFormVisible(!isFormVisible)} /> : null}
        </div>
        {isFormVisible && <BBFForm />}
        <Table columns={columns} items={items} className={"bbf-table"} sortable={false} actions={[]} />
      </Content>
    </Page>
  );
};
export default BBFPage;
